// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
let _fetch;

/* if running on EDGE runtime with global fetch*/
if (globalThis.fetch) {
    _fetch = async function fetch(
        uri: {
            host: string;
            path: string;
            secret: string;
        },
        okStatusCodes: number[] = []
    ): Promise<string> {
        try {
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), 2000);

            const resp = await globalThis.fetch(
                new URL(uri.path, `https://${uri.host}`).toString(),
                {
                    headers: {
                        'x-zoopla-secret-header': uri.secret
                    },
                    signal: controller.signal
                }
            );

            clearTimeout(timeout);

            if (
                okStatusCodes.length > 0 &&
                okStatusCodes.includes(resp?.status)
            ) {
                return resp.json();
            }

            if (resp?.status >= 400) {
                const err = new Error(
                    `${resp?.status} - ${resp.statusText}: ${uri.host}${uri.path}`
                );
                err.name = 'non_ok_code';
                throw err;
            }

            return resp.json();
        } catch (e) {
            if (e.name === 'AbortError') {
                throw new Error(`timeout: ${uri.host}${uri.path}`);
            }
            if (e.name === 'non_ok_code') {
                throw e;
            }
            throw new Error(`${uri.host}${uri.path}: ${e.message}`);
        }
    };
}

if (!globalThis.fetch) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { get, Agent } = require('https');
    const agent = new Agent({ keepAlive: true });

    _fetch = function fetch(
        uri: {
            host: string;
            path: string;
            secret: string;
        },
        okStatusCodes: number[] = []
    ): Promise<string> {
        return new Promise((res, rej) => {
            const options = {
                host: uri.host,
                path: uri.path,
                timeout: 1000,
                headers: {
                    'x-zoopla-secret-header': uri.secret
                },
                agent
            };

            const req = get(options, (resp) => {
                let data = '';

                resp.on('data', (chunk) => {
                    data += chunk;
                });

                resp.on('end', () => {
                    if (
                        okStatusCodes.length > 0 &&
                        okStatusCodes.includes(resp?.statusCode)
                    ) {
                        return res(JSON.parse(data));
                    }

                    if (resp?.statusCode >= 400) {
                        return rej(
                            `${resp?.statusCode} - ${resp.statusMessage}: ${uri.host}${uri.path}`
                        );
                    }

                    return res(JSON.parse(data));
                });
            });

            req.setTimeout(2000);

            req.on('timeout', () => {
                req.destroy();
                rej(`timeout: ${uri.host}${uri.path}`);
            });

            req.on('error', (err) => {
                if (req.aborted) return;

                rej(`${uri.host}${uri.path}: ${err.message}`);
            });
        });
    };
}

export { _fetch as fetch };
